import { ReactElement } from 'react';
import Slide1Content from './slides/Slide1';
import Slide2Content from './slides/Slide2';
import Slide3Content from './slides/Slide3';
import Slide4Content from './slides/Slide4';
import Slide5Content from './slides/Slide5';
import Slide6Content from './slides/Slide6';
import Slide7Content from './slides/Slide7';
import Slide7_1Content from './slides/Slide7_1';
import Slide8Content from './slides/Slide8';
import Slide9Content from './slides/Slide9';
import Slide10Content from './slides/slide10';
import { Cover } from './slides/premium/cover/cover';
import { WhatYouWantToAccomplish } from './slides/premium/what-you-want-to-accomplish/what-you-want-to-accomplish';
import { GuidingPhilosophy } from './slides/premium/guiding-philosophy/guiding-philosophy';
import { ExplanationOfModels } from './slides/premium/explanation-of-models/explanation-of-models';
import { StrategySelection } from './slides/premium/stategy-selection/stategy-selection';
import { StrategyAllocation } from './slides/premium/stategy-allocation/stategy-allocation';
import { PerformanceDisclosures } from './slides/premium/performance-disclosures/performance-disclosures';
import { ExcessReturnPerformance } from './slides/premium/excess-return-performance/excess-return-performance';
import { RiskAnalysis } from './slides/premium/risk-analysis/risk-analysis';
import { PortfolioCharacteristics } from './slides/premium/portfolio-characteristics/portfolio-characteristics';
import { PortfolioStory } from './slides/premium/portfolio-story/portfolio-story';
import { AMKProfiles } from './slides/premium/amk-profiles/amk-profiles';
import { Disclosures } from './slides/premium/disclosures';
import { TableOfContents } from './slides/premium/table-of-contents/table-of-contents';
import { SampleModelDifferencesContent } from './slides/SampleModelDifferences';
import { AMKProfiles2 } from './slides/premium/amk-profiles/amk-profiles2';
import { FinalPortfolioStory } from './slides/FinalPortfolioStory';

export type Slide<T> = {
  id: number;
  content: T;
  slideTemplateId?: string;
  slideTemplate?: ReactElement;
  pptTemplateId?: string;
};

export const slidesComponents: Record<
  number,
  (props: {
    slide: Slide<any>;
    onChangeSlide: (slide: Slide<any>, content: any) => void;
  }) => React.ReactNode
> = {
  0: Slide1Content,
  1: Slide2Content,
  2: Slide3Content,
  3: Slide4Content,
  4: Slide5Content,
  5: Slide6Content,
  6: Slide7Content,
  7: Slide8Content,
  24: Slide7_1Content,
  8: Slide9Content,
  9: Slide10Content,
  10: Cover,
  11: WhatYouWantToAccomplish,
  12: GuidingPhilosophy,
  13: ExplanationOfModels,
  14: StrategySelection,
  15: StrategyAllocation,
  16: PerformanceDisclosures,
  17: ExcessReturnPerformance,
  18: RiskAnalysis,
  19: PortfolioCharacteristics,
  20: PortfolioStory,
  21: AMKProfiles,
  22: Disclosures,
  23: TableOfContents,
  25: SampleModelDifferencesContent,
  26: AMKProfiles2,
  27: FinalPortfolioStory,
};
